.textAreaInput {
  --ixf-input-height: unset;
  --ixf-text-area-input-font-weight: var(--ixf-font-weight-main-regular);
  --ixf-input-label-active-offset: 0.5rem;

  position: relative;
  width: 100%;

  &.hasValue {
    .field {
      --ixf-input-padding: calc(
          var(--ixf-input-padding-vertical) +
            var(--ixf-input-label-active-offset) + var(--ixf-input-label-gap)
        )
        var(--ixf-input-padding-horizontal)
        calc(
          var(--ixf-input-padding-vertical) - var(
              --ixf-input-label-active-offset
            ) - var(--ixf-input-label-gap)
        )
        var(--ixf-input-padding-horizontal);
    }
  }

  .inputElement {
    border-left: var(--ixf-input-border-weight) solid
      var(--ixf-input-border-color);
    border-right: var(--ixf-input-border-weight) solid
      var(--ixf-input-border-color);

    &:first-of-type {
      border-top: var(--ixf-input-border-weight) solid
        var(--ixf-input-border-color);
      border-top-left-radius: var(--ixf-input-border-radius);
      border-top-right-radius: var(--ixf-input-border-radius);

      > textarea {
        border-top-left-radius: var(--ixf-input-border-radius);
        border-top-right-radius: var(--ixf-input-border-radius);
      }
    }

    &:last-of-type {
      border-bottom: var(--ixf-input-border-weight) solid
        var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);

      > textarea {
        border-bottom-left-radius: var(--ixf-input-border-radius);
        border-bottom-right-radius: var(--ixf-input-border-radius);
      }
    }
  }

  .label {
    --ixf-label-line-height: 1.125rem;
  }

  .field {
    display: inline-flex;
    flex: 1 1 auto;
    width: 100%;
    resize: none;
    font-size: var(--ixf-input-font-size);
    line-height: var(--ixf-input-line-height);
    font-weight: var(--ixf-text-area-input-font-weight);
    padding: var(--ixf-input-padding);

    &:focus {
      outline: none;
    }

    &::placeholder,
    &.isEmptyMask {
      color: var(--ixf-input-placeholder-color);
    }
  }
}
